/**
 * Type definitions for Chat Widget
 */

export interface SupportTicket {
  ticket_id: string;
  subject: string;
  status: 'open' | 'in_progress' | 'waiting_customer' | 'resolved' | 'closed';
  priority: 'low' | 'medium' | 'high' | 'critical';
  messages: SupportMessage[];
  created_at: string;
  updated_at: string;
}

export interface SupportMessage {
  message_id: string;
  from_user_id: string;
  from_user_name?: string;
  message: string;
  is_support_reply: boolean;
  created_at: string;
}

export interface Broadcast {
  broadcast_id: string;
  title: string;
  message: string;
  priority: 'info' | 'warning' | 'critical';
  sender_name?: string;
  created_at: string;
  read_by: string[];
}

export interface Conversation {
  conversation_id: string;
  participants: string[];
  last_message?: ChatMessage;
  unread_count: number;
  updated_at: string;
}

export interface ChatMessage {
  message_id: string;
  from_user_id: string;
  to_user_id: string;
  message: string;
  read_at?: string;
  created_at: string;
}

export interface ChatUser {
  id: string;
  name: string;
  email: string;
  organization: string;
}

export interface FaqItem {
  faq_id: string;
  question: string;
  answer: string;
  sort_order: number;
  created_at: string;
  updated_at: string;
  created_by: string | null;
  source_ticket_id?: string | null;
}

export type TabType = 'support' | 'chat' | 'broadcasts' | 'faq';
export type SupportView = 'list' | 'new' | 'ticket';
export type ChatView = 'list' | 'users' | 'conversation';

// Status colors
export const STATUS_COLORS = {
  open: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  in_progress: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
  waiting_customer: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200',
  resolved: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  closed: 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200',
} as const;

// Priority colors
export const PRIORITY_COLORS = {
  low: 'text-textTertiary',
  medium: 'text-blue-500',
  high: 'text-orange-500',
  critical: 'text-red-500',
} as const;

// Broadcast priority colors
export const BROADCAST_PRIORITY_COLORS = {
  info: 'border-l-blue-500',
  warning: 'border-l-yellow-500',
  critical: 'border-l-red-500',
} as const;
